<nav class="navbar navbar-expand navbar-light bg-light event-create-edit-nav pl-2">
  <ul class="navbar-nav">
    <li class="nav-item">
      <a routerLink="/events/setup/edit/{{ eventType ? eventType.id : '' }}/details"
         routerLinkActive="active"
         [class.disabled]="loadingEventType"
         class="nav-link" href="#">
        Event Details
      </a>
    </li>
    <li class="nav-item">
      <a *ngIf="!eventType || eventType.schedule_type !== ScheduleType.rolling"
         routerLink="/events/setup/edit/{{ eventType ? eventType.id : '' }}/pricing-matrices"
         routerLinkActive="active"
         [class.disabled]="loadingEventType"
         class="nav-link" href="#">
        Pricing
      </a>
      <a *ngIf="eventType && eventType.schedule_type === ScheduleType.rolling"
         routerLink="/events/setup/edit/{{ eventType ? eventType.id : '' }}/pricing-membership"
         routerLinkActive="active"
         [class.disabled]="loadingEventType"
         class="nav-link" href="#">
        Membership
      </a>
    </li>
    <li class="nav-item"
        *ngIf="!loadingEventType && eventType && (eventType.schedule_type === ScheduleType.rolling)">
      <a routerLink="/events/setup/edit/{{ eventType ? eventType.id : ''}}/rosters"
         routerLinkActive="active"
         class="nav-link" href="#">
        Rosters
      </a>
    </li>
    <li class="nav-item">
      <a routerLink="/events/setup/edit/{{ eventType ? eventType.id : '' }}/schedules"
         routerLinkActive="active"
         [class.disabled]="loadingEventType"
         class="nav-link" href="#">
        <ng-container *ngIf="loadingEventType">
          Loading...
        </ng-container>
        <ng-container *ngIf="!loadingEventType">
          {{ (eventType && (eventType.schedule_type === ScheduleType.oneOff)) ? 'Occurrences' : 'Schedules' }}
        </ng-container>
      </a>
    </li>
    <li class="nav-item"
        *ngIf="!loadingEventType && eventType && (eventType.schedule_type !== ScheduleType.oneOff)">
      <a routerLink="/events/setup/edit/{{ eventType ? eventType.id : ''}}/schedule-exceptions"
         routerLinkActive="active"
         class="nav-link" href="#">
        Schedule Exceptions
      </a>
    </li>
    <li class="nav-item"
        *ngIf="!loadingEventType && eventType && (eventType.schedule_type !== ScheduleType.rolling)">
      <a routerLink="/events/setup/edit/{{ eventType ? eventType.id : '' }}/questions"
         routerLinkActive="active"
         [class.disabled]="loadingEventType"
         class="nav-link" href="#">
        Questions
      </a>
    </li>
    <li class="nav-item">
      <a routerLink="/events/setup/edit/{{ eventType ? eventType.id : '' }}/columns"
         routerLinkActive="active"
         [class.disabled]="loadingEventType"
         class="nav-link" href="#">
        Columns
      </a>
    </li>
    <li class="nav-item"
        *ngIf="!loadingEventType && eventType && (eventType.schedule_type !== ScheduleType.rolling)">
      <a routerLink="/events/setup/edit/{{ eventType ? eventType.id : '' }}/emails"
         routerLinkActive="active"
         [class.disabled]="loadingEventType"
         class="nav-link" href="#">
        Emails
      </a>
    </li>
    <li class="nav-item"
        *ngIf="!loadingEventType && eventType && (eventType.schedule_type !== ScheduleType.rolling)">
      <a routerLink="/events/setup/edit/{{ eventType ? eventType.id : '' }}/cancellation-policy"
         routerLinkActive="active"
         [class.disabled]="loadingEventType"
         class="nav-link" href="#">
        Cancellation Policy
      </a>
    </li>
    <li class="nav-item">
      <a routerLink="/events/setup/edit/{{ eventType ? eventType.id : '' }}/waitlist"
         routerLinkActive="active"
         [class.disabled]="loadingEventType"
         class="nav-link" href="#">
        Waitlist
      </a>
    </li>
  </ul>
</nav>
